import React from "react";

import {withStyles} from "@mui/styles";
import classNames from "classnames";
import '@ckeditor/ckeditor5-build-classic/build/translations/fr';

import {getIn} from 'formik';

import FormattedNumberWithCurrency from "../../formattedNumberWithCurrencies/formattedNumberWithCurrency";
import fieldStyle from "../../../assets/jss/views/formik/fieldStyle";

class PriceInputRenderer extends React.Component {
    static supports(props) {
        return 'price' === (props.as ?? props.type);
    }

    render() {
        const {currency, name, formikContext, classes, fieldClassName} = this.props;
        const errors = formikContext.errors;
        const fieldIsInError = getIn(errors, name);
        const value = getIn(formikContext.values, name);

        const fieldClasses = classNames({
            [" " + classes.field]: true,
            [" " + classes.fieldInvalid]: !!fieldIsInError && formikContext.touched,
            [" " + (fieldClassName ?? '')]: true,
        });

        const tmpProps = {...this.props};
        delete tmpProps.containerClassName;
        delete tmpProps.fieldClassName;
        return (
            <FormattedNumberWithCurrency
                value={value}
                currency={currency}
                onValueChange={(value) => formikContext.setFieldValue(name, value.floatValue)}
                className={fieldClasses}
                displayType={'input'}
                {...tmpProps}
            />
        );
    }
}

export default withStyles(fieldStyle)(PriceInputRenderer);
